export default __webpack_public_path__ + "static/media/blue-train-tracks.b7237ee5.svg";